import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as retrieveProjectTimeSheet from "./retrieveProjectTimeSheet";
import * as saveTimeRecord from "./saveTimeRecord";
import * as validateTimeRecordsUpToDate from "./validateTimeRecordsUpToDate";
import * as retrievePersonalTimeSheet from "./retrievePersonalTimeSheet";
import * as validatePersonalTimeRecordsUpToDate from "./validatePersonalTimeRecordsUpToDate";
import * as reloadTimeSheet from "./reloadTimeSheet";
import * as reloadProjectTimeSheet from "./reloadProjectTimeSheet";
import * as retrieveTimeSheet from "./retrieveTimeSheet";
import * as retrieveWeekTimeRecords from "./retrieveWeekTimeRecords";
import * as deleteTimeRecord from "./deleteTimeRecord";

const initialState: State = {
  retrieveProjectTimeSheet: retrieveProjectTimeSheet.initialState,
  saveTimeRecord: saveTimeRecord.initialState,
  validateTimeRecordsUpToDate: validateTimeRecordsUpToDate.initialState,
  retrievePersonalTimeSheet: retrievePersonalTimeSheet.initialState,
  validatePersonalTimeRecordsUpToDate:
    validatePersonalTimeRecordsUpToDate.initialState,
  reloadTimeSheet: reloadTimeSheet.initialState,
  reloadProjectTimeSheet: reloadProjectTimeSheet.initialState,
  retrieveTimeSheet: retrieveTimeSheet.initialState,
  retrieveWeekTimeRecords: retrieveWeekTimeRecords.initialState,
  deleteTimeRecord: deleteTimeRecord.initialState,
};

const reduceState = combineStateReducer(initialState, {
  retrieveProjectTimeSheet: retrieveProjectTimeSheet.reduceState,
  saveTimeRecord: saveTimeRecord.reduceState,
  validateTimeRecordsUpToDate: validateTimeRecordsUpToDate.reduceState,
  retrievePersonalTimeSheet: retrievePersonalTimeSheet.reduceState,
  validatePersonalTimeRecordsUpToDate:
    validatePersonalTimeRecordsUpToDate.reduceState,
  reloadTimeSheet: reloadTimeSheet.reduceState,
  reloadProjectTimeSheet: reloadProjectTimeSheet.reduceState,
  retrieveTimeSheet: retrieveTimeSheet.reduceState,
  retrieveWeekTimeRecords: retrieveWeekTimeRecords.reduceState,
  deleteTimeRecord: deleteTimeRecord.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...retrieveProjectTimeSheet.createSelector(
      () => getState().retrieveProjectTimeSheet,
    ),
    ...saveTimeRecord.createSelector(() => getState().saveTimeRecord),
    ...validateTimeRecordsUpToDate.createSelector(
      () => getState().validateTimeRecordsUpToDate,
    ),
    ...retrievePersonalTimeSheet.createSelector(
      () => getState().retrievePersonalTimeSheet,
    ),
    ...validatePersonalTimeRecordsUpToDate.createSelector(
      () => getState().validatePersonalTimeRecordsUpToDate,
    ),
    ...reloadTimeSheet.createSelector(() => getState().reloadTimeSheet),
    ...reloadProjectTimeSheet.createSelector(
      () => getState().reloadProjectTimeSheet,
    ),
    ...retrieveTimeSheet.createSelector(() => getState().retrieveTimeSheet),
    ...retrieveWeekTimeRecords.createSelector(
      () => getState().retrieveWeekTimeRecords,
    ),
    ...deleteTimeRecord.createSelector(() => getState().deleteTimeRecord),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
